import React from "react";

const AboutMe = () => {
  return (
    <div className="flex flex-col md:flex-row pb-6">
      <div className="w-full md:w-1/2 text-zinc-400 px-6 border-r-[1px] border-r-zinc-800 flex items-center">
        <div className="py-6">
          <h2 className="font-semibold mb-1">Hello! I'm  Marcelo Ramos</h2>
          <p className="text-base leading-6 ">
          Brazilian-Portuguese Software Engineer in Lisbon. Specialized in backend development using C#, Python, and Java, and frontend development with React and TypeScript. Experienced with SQL and NoSQL databases. Holds a degree in Mobile Device Development and is currently pursuing a degree in Software Engineering.
          </p>
        </div>
      </div>
      <div className="w-full md:w-1/2 p-6">
        <ul className="flex flex-col gap-1">
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Age:</span>
            22
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Residence:</span>
            Portugal
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Freelance:</span>
            Available
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">Address:</span>
            Lisbon, PT
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AboutMe;
